// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"895":"1aa5014d8d0b280b","2818":"8642c978796a6060"}[chunkId] + ".css";
};